import { columnsGalleries } from '@/domain/env/colums-galleries';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Gallery } from '@/domain/types/collections';
import usePaginatedDocuments from '@/domain/use-cases/get-paginated-documents';
import Button from '@/presentation/components/button';
import LoadMoreButton from '@/presentation/components/load-more-button';
import Table from '@/presentation/components/table';
import { FiPlus } from 'react-icons/fi';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const GalleriesPage = () => {
  const navigate = useNavigate();
  const { data, error, isLoading, isLoadingMore, hasMore, loadMore } =
    usePaginatedDocuments<Gallery>(DOCUMENTS_DB.GALLERIES);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data.length && !isLoading) return <div>No hay datos</div>;

  const handleRowClick = (row: Gallery) => {
    navigate(`/dashboard/galleries/details/${row.id}`);
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Galerías</h1>
        <RouterLink to="/dashboard/galleries/add">
          <Button
            label="Agregar galería"
            icon={<FiPlus />}
            onClick={() => {}}
          />
        </RouterLink>
      </div>
      <Table data={data} columns={columnsGalleries} onRowClick={handleRowClick} />
      <LoadMoreButton hasMore={hasMore} isLoadingMore={isLoadingMore} onLoadMore={loadMore} />
    </div>
  );
};

export default GalleriesPage;
